module.exports = __webpack_public_path__ + "img/service-3.65e7eb42.png";